export default {
	teacherProfile: "老師資料",
	teacherHome: "達人主頁",
	search: "搜索",
	likes: "獲讚",
	followers: "追蹤者",
	follow: "追蹤",
	followed: "已追蹤",
	privateChat: "私聊",
	breadcrumb: "老師詳情",
	teacherIntro: "老師介紹",
	yearsExperience: "從業年限",
	serviceCount: "服務人數",
	rating: "評價",
	freeConsult: "免費諮詢",
	freeAssistantConsult: "免費咨詢助理",
	share: "分享",
	privacyTitle: "隱私保障",
	privacyDesc: "採用加密技術，保障您的個人信息和諮詢內容安全",
	sections: {
		consultService: "諮詢服務",
		solutionService: "解决方案",
		media: "媒體",
		userEvaluate: "用戶評價",
	},
	consultList: "諮詢服務列表",
	solutionList: "解决方案列表",
	mediaList: "媒體內容列表",
	evaluateList: "用戶評價列表",
	originalPrice: "原價{price}點數",
	finalPrice: "到手價",
	orderNow: "立即下單",
	serviceOrder: "立即下單",
	coinAlt: "點數",
	mediaShorts: "短視頻",
	mediaCourses: "公開課",
	mediaVideo: "視頻",
	mediaArticle: "文章",
	mediaViewCount: "{count}次觀看",
	mediaEmpty: "暫無媒體內容",
	mediaVideoEmpty: "暫無視頻",
	mediaArticleEmpty: "暫無文章",
	noData: "暫無數據",
	anonymousUser: "匿名用戶",
	prevPage: "上一頁",
	nextPage: "下一頁",
};
